import { useEffect } from 'react'

interface PageMeta {
  title: string
  description?: string
  ogImage?: string
}

const SITE_NAME = 'Avenir Théopolitain 2026'

/**
 * Hook impératif pour mettre à jour document.title et les meta tags OG existants.
 * Pas de dépendance externe — manipule le DOM directement via querySelector.
 */
export function usePageMeta({ title, description, ogImage }: PageMeta) {
  useEffect(() => {
    const fullTitle = title === SITE_NAME ? title : `${title} — ${SITE_NAME}`
    document.title = fullTitle

    setMetaTag('meta[property="og:title"]', fullTitle)
    setMetaTag('meta[name="twitter:title"]', fullTitle)

    if (description) {
      setMetaTag('meta[name="description"]', description)
      setMetaTag('meta[property="og:description"]', description)
      setMetaTag('meta[name="twitter:description"]', description)
    }

    if (ogImage) {
      setMetaTag('meta[property="og:image"]', ogImage)
      setMetaTag('meta[name="twitter:image"]', ogImage)
    }

    setMetaTag('meta[property="og:url"]', window.location.href)
  }, [title, description, ogImage])
}

function setMetaTag(selector: string, content: string) {
  const el = document.querySelector(selector)
  if (el) {
    el.setAttribute('content', content)
  }
}
